import { render, staticRenderFns } from "./ProductUpsert.vue?vue&type=template&id=3b860658&"
import script from "./ProductUpsert.vue?vue&type=script&lang=js&"
export * from "./ProductUpsert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports